import React from 'react';
import PropTypes from 'prop-types';
import Button from '@Components/Button';

function HeaderInfoIcon({ tooltipId, informationIconTitle, ariaLabel, e2eName }) {
  return (
    <Button
      buttonConfig={{
        className: 'info-tooltip',
        type: 'link',
        size: 'lg',
        e2eName,
        iconOnly: true,
        ariaLabel,
      }}
      iconConfig={{
        name: 'information-notitle',
        size: 'sm',
        noBorder: true,
        title: informationIconTitle,
      }}
      data-for={tooltipId}
      data-event="click"
      data-tip
    />
  );
}

export default HeaderInfoIcon;

HeaderInfoIcon.defaultProps = {
  e2eName: 'info-tooltip',
};

HeaderInfoIcon.propTypes = {
  tooltipId: PropTypes.string.isRequired,
  informationIconTitle: PropTypes.string,
  ariaLabel: PropTypes.string,
  e2eName: PropTypes.string,
};
